<template>
  <div>
    <div id="step_1" v-show="step == 1">
      <!-- 標題 進度 -->
      <section class="title-box">
        <div class="container">
          <h1>{{ $t("卡片資料") }}</h1>
          <ul class="progress-box">
            <li class="active">{{ $t("選擇卡片類型") }}</li>
            <li class="arrow"></li>
            <li class="">{{ $t("填寫基本資料") }}</li>
            <li class="arrow"></li>
            <li class="">{{ $t("確認資料") }}</li>
          </ul>
        </div>
      </section>
      <!-- 基本資料 -->
      <section>
        <div class="container">
          <div class="information-box">
            <h2>{{ $t("選擇卡片類型") }}</h2>
            <hr />
            <div class="form-group">
              <label for="cardType">{{ $t("卡片類型") }}</label>
              <select class="form-control" id="cardType" v-model="cardType" :disabled="CInfoData &&
                CInfoData.o_maas_cinfo_card_no != null &&
                CInfoData.o_maas_cinfo_card_no != ''
                ">
                <option value="-1" selected>{{ $t("請選擇") }}</option>
                <option value="0">{{ $t("TPASS/MeNGo/台南市民卡(二代卡)") }}</option>
                <option value="2">{{ $t("數位學生證") }}</option>
                <option value="3">{{ $t("QR Code") }}</option>
              </select>
            </div>
            <p class="notice" style="margin-top: 12px">
              注意：申請後無法更改。若您所持學生證背面為16碼，請選擇【數位學生證】
            </p>
            <div v-show="cardType == 2">
              <div class="form-group">
                <label for="expire">{{ $t("畢業年份") }}</label>
                <select class="form-control" id="expire" v-model="expire">
                  <option v-for="n in 10" :key="n">
                    {{ parseInt(currentYear) + (n - 1) }}
                  </option>
                </select>
              </div>
            </div>
            <div v-show="cardType == 0 || cardType == 2">
              <div class="form-group">
                <label for="cardNo">{{ $t("卡片背面號碼") }}</label>
                <input type="text" class="form-control" placeholder="" id="cardNo" v-model="cardNo" :disabled="CInfoData &&
                  CInfoData.o_maas_cinfo_card_no != null &&
                  CInfoData.o_maas_cinfo_card_no != ''
                  " />
              </div>
              <!-- 掃瞄照片上傳 -->
              <div class="photograph card-number" style="min-height: 30px" v-show="!CInfoData ||
                CInfoData.o_maas_cinfo_card_no == null ||
                CInfoData.o_maas_cinfo_card_no == ''
                " v-if="false">
                <button style="position: initial; margin-left: 5px" title="上傳檔案" @click="getFile('card_imgf')">
                  <img src="img/files.svg" alt="" />
                </button>
                <input type="file" class="custom-file-input" accept="image/jpg, image/jpeg, image/png" id="card_imgf"
                  style="display: none" />
                <button v-show="showPhotoButton" style="position: initial" title="拍攝照片" @click="getPhoto('card_imgf')">
                  <img src="img/photograph.svg" alt="" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <hr class="line" v-show="cardType == 0 || cardType == 2" />
      <!-- 卡片背面照 -->
      <section class="" v-show="cardType == 0 || cardType == 2">
        <div class="container">
          <div class="information-box">
            <h2>上傳卡片背面照片</h2>
            <hr />
            <div class="box img-preview" data-for="card_imgf" id="card_imgf_preview" style="
                background-repeat: no-repeat;
                background-position-x: center;
                background-position-y: center;
                background-size: contain;
              "></div>
            <input type="hidden" value="" id="card_imgf_data" />
            <div class="box" id="card_imgf_def">
              <p>
                {{
                  $t(
                    "格式：檔案僅接受jpg、png格式圖片檔，並小於5MB，照片需清晰且可辨認。"
                  )
                }}
              </p>
            </div>
            <div style="text-align: center">
              <div class="custom-file" style="left: 50px; margin-top: 10px; margin-bottom: 10px">
                {{ $t("選擇檔案") }}
                <input type="file" class="custom-file-input" accept="image/jpg, image/jpeg, image/png"
                  id="noocr_card_imgf" />
              </div>
              <div class="custom-file" style="
                  cursor: pointer;
                  left: 50px;
                  margin-top: 10px;
                  margin-bottom: 10px;
                " @click="getPhoto('noocr_card_imgf')" v-show="showPhotoButton">
                {{ $t("拍攝照片") }}
              </div>
            </div>
          </div>
        </div>
      </section>
      <hr class="line" />
      <!-- 大頭照 -->
      <section class="" v-if="false">
        <div class="container">
          <div class="information-box">
            <h2>上傳大頭照</h2>
            <hr />
            <div class="box img-preview" data-for="photo_img" id="photo_img_preview" style="
                background-repeat: no-repeat;
                background-position-x: center;
                background-position-y: center;
                background-size: contain;
              "></div>
            <input type="hidden" value="" id="photo_img_data" />
            <div class="box" id="photo_img_def">
              <p>
                {{
                  $t(
                    "格式：檔案僅接受jpg、png格式圖片檔，並小於5MB，照片需清晰且可辨認。"
                  )
                }}
              </p>
            </div>
            <div style="text-align: center">
              <div class="custom-file" style="left: 50px; margin-top: 10px; margin-bottom: 10px">
                {{ $t("選擇檔案") }}
                <input type="file" class="custom-file-input" accept="image/jpg, image/jpeg, image/png" id="photo_img" />
              </div>
              <div class="custom-file" style="
                  cursor: pointer;
                  left: 50px;
                  margin-top: 10px;
                  margin-bottom: 10px;
                " @click="getPhoto('photo_img')" v-show="showPhotoButton">
                {{ $t("拍攝照片") }}
              </div>
            </div>
          </div>
        </div>
      </section>
      <div class="btn-box">
        <!-- 下一步 -->
        <section class="next-btn">
          <button @click="gotoStep(2)">{{ $t("下一步") }}</button>
        </section>
      </div>
    </div>
    <div id="step_2" v-show="step == 2">
      <!-- 標題 進度 -->
      <section class="title-box">
        <div class="container">
          <h1>{{ $t("卡片資料") }}</h1>
          <ul class="progress-box">
            <li class="">{{ $t("選擇卡片類型") }}</li>
            <li class="arrow"></li>
            <li class="active">{{ $t("填寫基本資料") }}</li>
            <li class="arrow"></li>
            <li class="">{{ $t("確認資料") }}</li>
          </ul>
        </div>
      </section>
      <section class="id">
        <div class="container">
          <div class="information-box">
            <h2>基本資料</h2>
            <hr />
            <div class="btn-box">
              <button :class="ident_type == 1 ? 'add' : ''" @click="ident_type = 1">
                身分證
              </button>
              <button :class="ident_type == 2 ? 'add' : ''" @click="ident_type = 2">
                居留證
              </button>
            </div>
            <div class="text-box" :class="ident_type == 1 ? 'add' : ''">
              <!-- 掃瞄照片上傳 -->
              <div class="photograph id-card">
                <!-- <button title="上傳檔案" @click="getFile('id_img')">
                  <img src="img/files.svg" alt="" />
                </button>
                <input type="file" class="custom-file-input" accept="image/jpg, image/jpeg, image/png" id="id_img"
                  style="display: none" />
                <button v-show="showPhotoButton" title="拍攝照片" @click="getPhoto('id_img')">
                  <img src="img/photograph.svg" alt="" />
                </button>
                <p style="margin-top: 40px" type="button" class="btn" data-toggle="modal"
                  data-target="#ocrCaptionModal">
                辨識說明>
                </p> -->
                <button type="button" data-toggle="modal" data-target="#ocrCaptionModal" class="btn">證件辨識</button>
              </div>
              <p>身分證正面</p>
              <hr />
              <div class="box img-preview" data-for="id_img" id="id_img_preview" style="
                  background-repeat: no-repeat;
                  background-position-x: center;
                  background-position-y: center;
                  background-size: contain;
                "></div>
              <input type="hidden" value="" id="id_img_data" />
              <div class="box" id="id_img_def">
                <p>
                  {{
                    $t(
                      "格式：檔案僅接受jpg、png格式圖片檔，並小於5MB，照片需清晰且可辨認。"
                    )
                  }}
                </p>
              </div>
              <div style="text-align: center">
                <div class="custom-file" style="left: 50px; margin-top: 10px; margin-bottom: 10px">
                  {{ $t("選擇檔案") }}
                  <input type="file" class="custom-file-input" accept="image/jpg, image/jpeg, image/png"
                    id="noocr_id_img" />
                </div>
                <div class="custom-file" style="
                    cursor: pointer;
                    left: 50px;
                    margin-top: 10px;
                    margin-bottom: 10px;
                  " @click="getPhoto('noocr_id_img')" v-show="showPhotoButton">
                  {{ $t("拍攝照片") }}
                </div>
              </div>
              <div class="form-group">
                <label for="ident">身分證號</label>
                <input type="text" class="form-control" placeholder="" id="ident" v-model="ident" />
              </div>
              <div class="form-group">
                <label for="name">姓名</label>
                <input type="text" class="form-control" placeholder="" id="name" v-model="name" />
              </div>
              <div class="form-group">
                <label for="birth">出生年月</label>
                <input type="text" class="form-control" id="birth" placeholder="輸入格式: yyy(民國年)/mm/dd" v-model="birth" />
              </div>
              <div class="form-group">
                <label for="issue_date">發證日期</label>
                <input type="text" class="form-control" id="issue_date" placeholder="輸入格式: yyy(民國年)/mm/dd"
                  v-model="issue_date" />
              </div>
              <div class="form-group">
                <label for="issue_place">發證地點</label>
                <select class="form-control" id="issue_place" v-model="issue_place">
                  <option value="" selected>請選擇</option>
                  <option value="北縣">北縣</option>
                  <option value="宜縣">宜縣</option>
                  <option value="桃縣">桃縣</option>
                  <option value="竹縣">竹縣</option>
                  <option value="苗縣">苗縣</option>
                  <option value="中縣">中縣</option>
                  <option value="彰縣">彰縣</option>
                  <option value="投縣">投縣</option>
                  <option value="雲縣">雲縣</option>
                  <option value="嘉縣">嘉縣</option>
                  <option value="南縣">南縣</option>
                  <option value="高縣">高縣</option>
                  <option value="屏縣">屏縣</option>
                  <option value="東縣">東縣</option>
                  <option value="花縣">花縣</option>
                  <option value="澎縣">澎縣</option>
                  <option value="基市">基市</option>
                  <option value="竹市">竹市</option>
                  <option value="嘉市">嘉市</option>
                  <option value="連江">連江</option>
                  <option value="金門">金門</option>
                  <option value="北市">北市</option>
                  <option value="高市">高市</option>
                  <option value="新北市">新北市</option>
                  <option value="中市">中市</option>
                  <option value="南市">南市</option>
                  <option value="桃市">桃市</option>
                </select>
              </div>
              <div class="form-group">
                <label for="issue_type">領補換證類別</label>
                <select class="form-control" id="issue_type" v-model="issue_type">
                  <option value="" selected>請選擇</option>
                  <option value="初發">{{ $t("初發") }}</option>
                  <option value="補發">{{ $t("補發") }}</option>
                  <option value="換發">{{ $t("換發") }}</option>
                </select>
              </div>
              <br />
            </div>
            <div class="text-box" :class="ident_type == 2 ? 'add' : ''">
              <div class="form-group">
                <label for="visa_ident">統一證號</label>
                <input type="text" class="form-control" placeholder="" id="visa_ident" v-model="ident" />
              </div>
              <div class="form-group">
                <label for="visa_country">國籍</label>
                <select class="form-control" id="visa_country" v-model="visa_country">
                  <option value="0" selected>{{ $t("台灣") }}</option>
                  <option value="1">{{ $t("其他") }}</option>
                  <option value="2">{{ $t("中國") }}</option>
                  <option value="3">{{ $t("港澳") }}</option>
                  <option value="4">{{ $t("日本") }}</option>
                  <option value="5">{{ $t("韓國") }}</option>
                  <option value="6">{{ $t("東南亞") }}</option>
                </select>
              </div>
              <div class="form-group">
                <label for="visa_name">姓名</label>
                <input type="text" class="form-control" placeholder="" id="visa_name" v-model="name" />
              </div>
              <div class="form-group">
                <label for="visa_birth">出生年月</label>
                <input type="text" class="form-control" id="visa_birth" placeholder="輸入格式: yyy(民國年)/mm/dd"
                  v-model="birth" />
              </div>
              <div class="form-group">
                <label for="visa_issue_date">發證日期</label>
                <input type="text" class="form-control" id="visa_issue_date" placeholder="輸入格式: yyy(民國年)/mm/dd"
                  v-model="issue_date" />
              </div>
              <div class="form-group expiration">
                <label for="visa_limit_date">居留期限</label>
                <input type="text" class="form-control" id="visa_limit_date" placeholder="輸入格式: yyy(民國年)/mm/dd"
                  v-model="visa_limit_date" />
              </div>
              <div class="check-box">
                <input class="" id="visa_no_limit" type="checkbox" v-model="visa_no_limit" />
                <label style="margin-top: 0.5rem; margin-left: 0.25rem" for="visa_no_limit">外僑永久居留證</label>
              </div>
              <p>居留證正面</p>
              <hr />
              <div class="box img-preview" data-for="visa_img" id="visa_img_preview" style="
                  background-repeat: no-repeat;
                  background-position-x: center;
                  background-position-y: center;
                  background-size: contain;
                "></div>
              <input type="hidden" value="" id="visa_img_data" />
              <div class="box" id="visa_img_def">
                <p>
                  {{
                    $t(
                      "格式：檔案僅接受jpg、png格式圖片檔，並小於5MB，照片需清晰且可辨認。"
                    )
                  }}
                </p>
              </div>
              <div style="text-align: center">
                <div class="custom-file" style="left: 50px; margin-top: 10px; margin-bottom: 10px">
                  {{ $t("選擇檔案") }}
                  <input type="file" class="custom-file-input" accept="image/jpg, image/jpeg, image/png"
                    id="visa_img" />
                </div>
                <div class="custom-file" style="
                    cursor: pointer;
                    left: 50px;
                    margin-top: 10px;
                    margin-bottom: 10px;
                  " @click="getPhoto('visa_img')" v-show="showPhotoButton">
                  {{ $t("拍攝照片") }}
                </div>
              </div>
              <p>居留證反面</p>
              <hr />
              <div class="box img-preview" data-for="visa_imgf" id="visa_imgf_preview" style="
                  background-repeat: no-repeat;
                  background-position-x: center;
                  background-position-y: center;
                  background-size: contain;
                "></div>
              <input type="hidden" value="" id="visa_imgf_data" />
              <div class="box" id="visa_imgf_def">
                <p>
                  {{
                    $t(
                      "格式：檔案僅接受jpg、png格式圖片檔，並小於5MB，照片需清晰且可辨認。"
                    )
                  }}
                </p>
              </div>
              <div style="text-align: center">
                <div class="custom-file" style="left: 50px; margin-top: 10px; margin-bottom: 10px">
                  {{ $t("選擇檔案") }}
                  <input type="file" class="custom-file-input" accept="image/jpg, image/jpeg, image/png"
                    id="visa_imgf" />
                </div>
                <div class="custom-file" style="
                    cursor: pointer;
                    left: 50px;
                    margin-top: 10px;
                    margin-bottom: 10px;
                  " @click="getPhoto('visa_imgf')" v-show="showPhotoButton">
                  {{ $t("拍攝照片") }}
                </div>
              </div>
            </div>
            <hr />
            <div class="text-box add">
              <div class="form-group phone-box">
                <label for="phone">{{ $t("聯絡手機") }}</label>
                <input type="text" class="form-control" placeholder="" id="contact_mobile" v-model="contact_mobile" />
              </div>
            </div>
          </div>
          <div class="information-box member_friends mt-4" v-if="hasInvite">
            <h2>好友邀請碼</h2>
            <hr />
            <div class="text-box add">
              <div class="form-group phone-box">
                <label for="phone">{{ $t("請輸入收到的邀請碼") }}</label>
                <input type="text" class="form-control" placeholder="" id="invitCode" v-model="invitCode" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <div class="btn-box">
        <section class="prev-btn">
          <button @click="gotoStep(1)">{{ $t("上一步") }}</button>
        </section>
        <!-- 下一步 -->
        <section class="next-btn">
          <button @click="gotoStep(3)">{{ $t("下一步") }}</button>
        </section>
      </div>
    </div>
    <div id="step_3" v-show="step == 3">
      <!-- 標題 進度 -->
      <section class="title-box">
        <div class="container">
          <h1>{{ $t("卡片資料") }}</h1>
          <ul class="progress-box">
            <li class="">{{ $t("選擇卡片類型") }}</li>
            <li class="arrow"></li>
            <li class="">{{ $t("填寫基本資料") }}</li>
            <li class="arrow"></li>
            <li class="active">{{ $t("確認資料") }}</li>
          </ul>
        </div>
      </section>
      <section class="notice-box">
        <div class="container">
          <div class="information-box">
            <h2>確認資料</h2>
            <hr />
            <p class="notice">
              提醒您，送出前請務必確認資料正確性，以免影響您自身權益！
              <br />
              確認提交後，請妥善保管您的票卡，記名審查結果將於APP內通知，未通知前仍屬非記名卡，無法受理退費．
            </p>
          </div>
        </div>
      </section>
      <hr class="line" />
      <section class="">
        <div class="container">
          <div class="information-box">
            <h2>卡片資料</h2>
            <hr />
            <div class="form-group">
              <label for="">卡片類型</label>
              <input v-show="cardType == 3" type="text" class="form-control" value="QRCode" readonly />
              <input v-show="cardType == 0" type="text" class="form-control" value="TPASS/MeNGo/台南市民卡(二代卡)" readonly />
              <input v-show="cardType == 2" type="text" class="form-control" value="數位學生證" readonly />
            </div>
            <div class="form-group" v-show="cardType == 2">
              <label for="">畢業年份</label>
              <input v-model="expire" type="text" class="form-control" readonly />
            </div>
            <div class="form-group" v-show="cardType == 0 || cardType == 2">
              <label for="">卡號</label>
              <input v-model="cardNo" type="text" class="form-control" readonly />
            </div>
          </div>
        </div>
      </section>
      <hr class="line" />
      <section class="" v-show="ident_type == 1">
        <div class="container">
          <div class="information-box">
            <h2>基本資料</h2>
            <hr />
            <div class="form-group">
              <label for="">姓名</label>
              <input v-model="name" type="text" class="form-control" readonly />
            </div>
            <div class="form-group">
              <label for="">身分證號</label>
              <input v-model="ident" type="text" class="form-control" readonly />
            </div>
            <div class="form-group">
              <label for="">出生年月</label>
              <input v-model="birth" type="text" class="form-control" readonly />
            </div>
            <div class="form-group">
              <label for="">發證日期</label>
              <input v-model="issue_date" type="text" class="form-control" readonly />
            </div>
            <div class="form-group">
              <label for="">發證地點</label>
              <input v-model="issue_place" type="text" class="form-control" readonly />
            </div>
            <div class="form-group">
              <label for="">領補換證類別</label>
              <input v-model="issue_type" type="text" class="form-control" readonly />
            </div>
            <div class="form-group">
              <label for="">聯絡手機</label>
              <input v-model="contact_mobile" type="text" class="form-control" readonly />
            </div>
          </div>
          <div class="information-box mt-4" v-if="hasInvite">
            <h2>好友邀請碼</h2>
            <hr />
            <div class="form-group">
              <label for="">好友邀請碼</label>
              <input v-model="invitCode" type="text" class="form-control" readonly />
            </div>
          </div>
        </div>
      </section>
      <section class="" v-show="ident_type == 2">
        <div class="container">
          <div class="information-box">
            <h2>基本資料</h2>
            <hr />
            <div class="form-group">
              <label for="">統一證號</label>
              <input v-model="ident" type="text" class="form-control" readonly />
            </div>
            <div class="form-group">
              <label for="">姓名</label>
              <input v-model="name" type="text" class="form-control" readonly />
            </div>
            <div class="form-group">
              <label for="">國籍</label>
              <input v-model="visa_country_text" type="text" class="form-control" value="臺灣" readonly />
            </div>
            <div class="form-group">
              <label for="">出生年月</label>
              <input v-model="birth" type="text" class="form-control" readonly />
            </div>
            <div class="form-group">
              <label for="">發證日期</label>
              <input v-model="issue_date" type="text" class="form-control" readonly />
            </div>
            <div class="form-group">
              <label for="">居留期限</label>
              <input v-model="visa_limit_date_text" type="text" class="form-control" readonly />
            </div>
            <div class="form-group">
              <label for="">聯絡手機</label>
              <input v-model="contact_mobile" type="text" class="form-control" readonly />
            </div>
          </div>
          <div class="information-box mt-4" v-if="hasInvite">
            <h2>好友邀請碼</h2>
            <hr />
            <div class="form-group">
              <label for="">好友邀請碼</label>
              <input v-model="invitCode" type="text" class="form-control" readonly />
            </div>
          </div>
        </div>
      </section>
      <div class="btn-box">
        <section class="prev-btn">
          <button @click="gotoStep(2)">{{ $t("上一步") }}</button>
        </section>
        <!-- 提交 -->
        <section class="next-btn">
          <button @click="cardApply()">{{ $t("提　交") }}</button>
        </section>
      </div>
    </div>
    <!-- 底部加高 底部固定選單fixed的高度 -->
    <div class="nav-menu-bg"></div>
    <!-- 0407 辨識說明 -->
    <div class="modal fade" id="ocrCaptionModal" tabindex="-1" aria-labelledby="ocrCaptionModalLabel"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="ocrCaptionModalLabel">證照辨識</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <div class="img-box">
              <img src="img/id-camera.png" alt="" />
            </div>

            <ul class="text">
              <li>
                請記得將證件擺正，手機拿「橫」拍，拍攝照片避免反光，需確認照片清晰。
              </li>

              <li>
                進行的上傳照片步驟，盡量將拍攝畫面邊框對準證件的四角，這樣上傳的大頭照片會更清晰。
              </li>

              <li>
                若證件磨損或是手機拍攝功能不佳，建議採用其他掃描設備儲存圖片後，使用照片上傳功能。
              </li>
            </ul>
            <hr>
            <div class="btn_box">
              <button @click="getFile('id_img')">
                <img src="img/files.svg" alt="">
                <p>上傳檔案</p>
              </button>
              <input type="file" class="custom-file-input" accept="image/jpg, image/jpeg, image/png" id="id_img"
                style="display: none" />
              <button v-show="showPhotoButton" @click="getPhoto('id_img')">
                <img src="img/photograph.svg" alt="">
                <p>拍攝照片</p>
              </button>
            </div>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn" data-dismiss="modal">返回</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import VueI18n from "vue-i18n";
import Storage from "@/utils/storage.js";

Vue.use(VueAxios, axios);
Vue.use(VueI18n);

// this.$t("立即購買")
const messages = {
  zh_tw: {
    卡片資料: "卡片資料",
    填寫基本資料: "填寫基本資料",
    上傳身分證: "上傳身分證",
    上傳大頭照: "上傳大頭照",
    基本資料: "基本資料",
    身分類別: "身分類別",
    請選擇: "請選擇",
    "TPASS/MeNGo/台南市民卡(二代卡)": "TPASS/MeNGo/台南市民卡(二代卡)",
    學生: "學生",
    數位學生證: "數位學生證",
    卡片背面號碼: "卡片背面號碼",
    畢業年份: "畢業年份",
    就讀學校: "就讀學校",
    "注意：若您所持學生證背面為16碼，請選擇【數位學生證】":
      "注意：若您所持學生證背面為16碼，請選擇【數位學生證】",
    姓名: "姓名",
    出生年月: "出生年月",
    性別: "性別",
    未設定: "未設定",
    男性: "男性",
    女性: "女性",
    國籍: "國籍",
    台灣: "台灣",
    其他: "其他",
    中國: "中國",
    港澳: "港澳",
    日本: "日本",
    韓國: "韓國",
    東南亞: "東南亞",
    身分證字號: "身分證字號",
    通訊地址: "通訊地址",
    縣市: "縣市",
    鄉鎮區: "鄉鎮區",
    "路、街、巷、弄、號、樓等": "路、街、巷、弄、號、樓等",
    電話: "電話",
    下一步: "下一步",
    上傳身分證正反面: "上傳身分證正反面",
    "為保障您的權益，MeN Go採用實名制認證，本系統使用最高規格資安保護，敬請安心上傳。":
      "為保障您的權益，MeN Go採用實名制認證，本系統使用最高規格資安保護，敬請安心上傳。",
    身份證正面: "身份證正面",
    "格式：檔案僅接受jpg、png格式圖片檔，並小於5MB，照片需清晰且可辨認。":
      "格式：檔案僅接受jpg、png格式圖片檔，並小於5MB，照片需清晰且可辨認。",
    選擇檔案: "選擇檔案",
    身份證反面: "身份證反面",
    學生證正面: "學生證正面",
    學生證反面: "學生證反面",
    上一步: "上一步",
    大頭照: "大頭照",
    圖片範本參考: "圖片範本參考",
    注意事項: "注意事項",
    "1.畫素至少需(高 X 寬) 531 pixels(像素) x 354 pixels(像素)。":
      "1.畫素至少需(高 X 寬) 531 pixels(像素) x 354 pixels(像素)。",
    "2.臉部需佔照片面積的 70%~80%。": "2.臉部需佔照片面積的 70%~80%。",
    "3.頭部或頭髮不得碰觸到相片邊框(女性長髮碰觸照片下緣例外)。":
      "3.頭部或頭髮不得碰觸到相片邊框(女性長髮碰觸照片下緣例外)。",
    "4.為 6 個月內、彩色、正面、半身、2吋脫帽之清晰大頭照片。":
      "4.為 6 個月內、彩色、正面、半身、2吋脫帽之清晰大頭照片。",
    "提　交": "提　交",
    "請稍候...": "請稍候...",
    錯誤: "錯誤",
    請上傳身分證正面照片: "請上傳身分證正面照片",
    確定: "確定",
    請上傳身分證反面照片: "請上傳身分證反面照片",
    請上傳學生證正面照片: "請上傳學生證正面照片",
    請上傳學生證反面照片: "請上傳學生證反面照片",
    請上傳大頭照: "請上傳大頭照",
    提交完成: "提交完成",
    "申請資料提交完成，您已可購買QR Code/卡片月週票搭乘各運具。＊欲使用實體卡片，請等候1-2個工作日，審核通過後進行購卡。":
      "申請資料提交完成，您已可購買QR Code/卡片月週票搭乘各運具。＊欲使用實體卡片，請等候1-2個工作日，審核通過後進行購卡。",
    選擇卡片類型: "選擇卡片類型",
    確認資料: "確認資料",
    卡片類型: "卡片類型",
    "QR Code": "QR Code",
    拍攝照片: "拍攝照片",
    確認資料: "確認資料",
    初發: "初發",
    補發: "補發",
    換發: "換發",
    聯絡手機: "聯絡手機",
  },
  en: {
    卡片資料: "Card info",
    填寫基本資料: "Fill in info",
    上傳身分證: "Upload the ID card",
    上傳大頭照: "Upload the photo",
    基本資料: "Basic info",
    身分類別: "Type",
    請選擇: "Please select",
    "TPASS/MeNGo/台南市民卡(二代卡)": "TPASS/MeNGo/TN card",
    學生: "Student",
    數位學生證: "Student ID card",
    卡片背面號碼: "Card number",
    畢業年份: "Year of graduation",
    就讀學校: "School attended",
    "注意：若您所持學生證背面為16碼，請選擇【數位學生證】":
      "Note: if the back of your student card contains 16 characters, please select Digital Student Card.",
    姓名: "Name",
    出生年月: "Date of birth",
    性別: "Gender",
    未設定: "Not set",
    男性: "Male",
    女性: "Female",
    國籍: "Nationality",
    台灣: "Taiwan",
    其他: "Others",
    中國: "China",
    港澳: "Hong Kong/Macau",
    日本: "Japan",
    韓國: "Korea",
    東南亞: "Southeast Asia",
    身分證字號: "ID No.",
    通訊地址: "Contact address",
    縣市: "County (City)",
    鄉鎮區: "Township, District",
    "路、街、巷、弄、號、樓等":
      "Road, Street, Lane, Alley, No., Building, etc.",
    電話: "Mobile phone",
    下一步: "Next",
    上傳身分證正反面: "Upload the front and back of your ID card",
    "為保障您的權益，MeN Go採用實名制認證，本系統使用最高規格資安保護，敬請安心上傳。":
      "In order to protect your rights and interests, MeN Go card adopts real-name authentication system with the highest information security protection. Please feel free to upload.",
    身份證正面: "Front of the ID card",
    "格式：檔案僅接受jpg、png格式圖片檔，並小於5MB，照片需清晰且可辨認。":
      "Format: the file can only be in JPG and PNG format, with the size smaller than 5MB. The photos must be clear and recognizable.",
    選擇檔案: "Select the file",
    身份證反面: "Back of the ID card",
    學生證正面: "Front of the student card",
    學生證反面: "Back of the student card",
    上一步: "Back",
    大頭照: "Photo",
    圖片範本參考: "Image sample",
    注意事項: "Notes",
    "1.畫素至少需(高 X 寬) 531 pixels(像素) x 354 pixels(像素)。":
      "1. Pixels must be at least (height X width) 531 pixels X 354 pixels.",
    "2.臉部需佔照片面積的 70%~80%。":
      "2. The face should cover 70 to 80 percent of the photo area.",
    "3.頭部或頭髮不得碰觸到相片邊框(女性長髮碰觸照片下緣例外)。":
      "3. The head or hair should not touch the frame of the photo (except for women with long hair touching the lower edge of the photo).",
    "4.為 6 個月內、彩色、正面、半身、2吋脫帽之清晰大頭照片。":
      "4. A 2-inch, full-face, half-length, hatless clear photo taken within 6 months.",
    "提　交": "Submit",
    "請稍候...": "Please wait a second...",
    錯誤: "Error",
    請上傳身分證正面照片: "Please upload the front photo of your ID card",
    確定: "Confirm",
    請上傳身分證反面照片: "Please upload the back photo of your ID card",
    請上傳學生證正面照片: "Please upload the front photo of your student card",
    請上傳學生證反面照片: "Please upload the back photo of your student card",
    請上傳大頭照: "Please upload your photo",
    提交完成: "Submitted",
    "申請資料提交完成，您已可購買QR Code/卡片月週票搭乘各運具。＊欲使用實體卡片，請等候1-2個工作日，審核通過後進行購卡。":
      "Membership under review before QR Code / Card pass can be purchased.*If card pass is required, please wait 1-2 days before purchase.",
    選擇卡片類型: "選擇卡片類型",
    確認資料: "確認資料",
    卡片類型: "卡片類型",
    "QR Code": "QR Code",
    拍攝照片: "拍攝照片",
    確認資料: "確認資料",
    初發: "初發",
    補發: "補發",
    換發: "換發",
    聯絡手機: "聯絡手機",
  },
  jp: {
    卡片資料: "卡片資料",
    填寫基本資料: "填寫基本資料",
    上傳身分證: "上傳身分證",
    上傳大頭照: "上傳大頭照",
    基本資料: "基本資料",
    身分類別: "身分類別",
    請選擇: "請選擇",
    "TPASS/MeNGo/台南市民卡(二代卡)": "TPASS/MeNGo/台南市民卡(二代卡)",
    學生: "學生",
    數位學生證: "數位學生證",
    卡片背面號碼: "卡片背面號碼",
    畢業年份: "畢業年份",
    就讀學校: "就讀學校",
    "注意：若您所持學生證背面為16碼，請選擇【數位學生證】":
      "注意：若您所持學生證背面為16碼，請選擇【數位學生證】",
    姓名: "姓名",
    出生年月: "出生年月",
    性別: "性別",
    未設定: "未設定",
    男性: "男性",
    女性: "女性",
    國籍: "國籍",
    台灣: "台灣",
    其他: "其他",
    中國: "中國",
    港澳: "港澳",
    日本: "日本",
    韓國: "韓國",
    東南亞: "東南亞",
    身分證字號: "身分證字號",
    通訊地址: "通訊地址",
    縣市: "縣市",
    鄉鎮區: "鄉鎮區",
    "路、街、巷、弄、號、樓等": "路、街、巷、弄、號、樓等",
    電話: "電話",
    下一步: "下一步",
    上傳身分證正反面: "上傳身分證正反面",
    "為保障您的權益，MeN Go採用實名制認證，本系統使用最高規格資安保護，敬請安心上傳。":
      "為保障您的權益，MeN Go採用實名制認證，本系統使用最高規格資安保護，敬請安心上傳。",
    身份證正面: "身份證正面",
    "格式：檔案僅接受jpg、png格式圖片檔，並小於5MB，照片需清晰且可辨認。":
      "格式：檔案僅接受jpg、png格式圖片檔，並小於5MB，照片需清晰且可辨認。",
    選擇檔案: "選擇檔案",
    身份證反面: "身份證反面",
    學生證正面: "學生證正面",
    學生證反面: "學生證反面",
    上一步: "上一步",
    大頭照: "大頭照",
    圖片範本參考: "圖片範本參考",
    注意事項: "注意事項",
    "1.畫素至少需(高 X 寬) 531 pixels(像素) x 354 pixels(像素)。":
      "1.畫素至少需(高 X 寬) 531 pixels(像素) x 354 pixels(像素)。",
    "2.臉部需佔照片面積的 70%~80%。": "2.臉部需佔照片面積的 70%~80%。",
    "3.頭部或頭髮不得碰觸到相片邊框(女性長髮碰觸照片下緣例外)。":
      "3.頭部或頭髮不得碰觸到相片邊框(女性長髮碰觸照片下緣例外)。",
    "4.為 6 個月內、彩色、正面、半身、2吋脫帽之清晰大頭照片。":
      "4.為 6 個月內、彩色、正面、半身、2吋脫帽之清晰大頭照片。",
    "提　交": "提　交",
    "請稍候...": "請稍候...",
    錯誤: "錯誤",
    請上傳身分證正面照片: "請上傳身分證正面照片",
    確定: "確定",
    請上傳身分證反面照片: "請上傳身分證反面照片",
    請上傳學生證正面照片: "請上傳學生證正面照片",
    請上傳學生證反面照片: "請上傳學生證反面照片",
    請上傳大頭照: "請上傳大頭照",
    提交完成: "提交完成",
    "申請資料提交完成，您已可購買QR Code/卡片月週票搭乘各運具。＊欲使用實體卡片，請等候1-2個工作日，審核通過後進行購卡。":
      "申請資料提交完成，您已可購買QR Code/卡片月週票搭乘各運具。＊欲使用實體卡片，請等候1-2個工作日，審核通過後進行購卡。",
    選擇卡片類型: "選擇卡片類型",
    確認資料: "確認資料",
    卡片類型: "卡片類型",
    "QR Code": "QR Code",
    拍攝照片: "拍攝照片",
    確認資料: "確認資料",
    初發: "初發",
    補發: "補發",
    換發: "換發",
    聯絡手機: "聯絡手機",
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

export default {
  name: "CardBind",
  i18n,
  data() {
    return {
      ident_type: 1,
      local: "zh_tw",
      currentYear:
        new Date().getMonth() >= 9
          ? new Date().getFullYear() + 1
          : new Date().getFullYear(),
      showPhotoButton: typeof device != "undefined" && device.platform != "iOS",
      expire:
        new Date().getMonth() >= 9
          ? new Date().getFullYear() + 1
          : new Date().getFullYear(),
      cardNo: "",
      cardType: -1,
      ident: "",
      name: "",
      birth: "",
      issue_date: "",
      issue_place: "",
      issue_type: "",
      visa_country: 0,
      visa_limit_date: "",
      visa_no_limit: false,
      visa_country_text: "",
      visa_limit_date_text: "",

      birth_real: "",
      issue_date_real: "",
      visa_limit_date_real: "",
      SiteUrl: "",
      CInfoData: {},

      contact_mobile: "",

      step: 1,

      IsTester: false,
      hasInvite: false,
      invitCode: "",
    };
  },
  watch: {
    verifyCodeCheck(newValue, oldValue) {
      switch (newValue) {
        case 0:
          this.visa_country_text = "台灣";
          break;
        case 1:
          this.visa_country_text = "其他";
          break;
        case 2:
          this.visa_country_text = "中國";
          break;
        case 3:
          this.visa_country_text = "港澳";
          break;
        case 4:
          this.visa_country_text = "日本";
          break;
        case 5:
          this.visa_country_text = "韓國";
          break;
        case 6:
          this.visa_country_text = "東南亞";
          break;
      }
    },
  },
  created: function () {
    let that = this;
    Vue.axios
      .get(this.GLOBAL.apiSrc + this.GLOBAL.subDirectory + "/Htmlv2/CardBind", {
        params: {
          token: Storage.get("ek_login_token"),
        },
      })
      .then((response) => {
        this.SiteUrl = response.data.SiteUrl;
        this.CInfoData = response.data.CInfoData;
        if (this.CInfoData != null) {
          if (this.CInfoData.o_maas_cinfo_card_no) {
            this.cardType = this.CInfoData.o_maas_cinfo_type;
          } else {
            this.cardType = 3;
          }
          // 2025-11-03 直接改用時間判斷啟始可選年份
          //this.currentYear = this.CInfoData.o_maas_cinfo_expire;
          this.cardNo = this.CInfoData.o_maas_cinfo_card_no;

          this.ident_type = this.CInfoData.o_maas_cinfo_ident_type;
          this.ident = this.CInfoData.o_maas_cinfo_ident;
          this.name = this.CInfoData.o_maas_cinfo_name;
          this.birth = this.CInfoData.o_maas_cinfo_birth;
          this.issue_date = this.CInfoData.o_maas_cinfo_issue_date;
          this.issue_place = this.CInfoData.o_maas_cinfo_issue_place;
          this.issue_type = this.CInfoData.o_maas_cinfo_issue_type;

          this.visa_country = this.CInfoData.o_maas_cinfo_nation;
          this.visa_limit_date = this.CInfoData.o_maas_cinfo_visa_limit_date;
          this.visa_no_limit = this.CInfoData.o_maas_cinfo_visa_no_limit;

          this.contact_mobile = this.CInfoData.o_maas_cinfo_contact_mobile;

          // var startDate = this.CInfoData.o_maas_cinfo_birth
          //   ? this.CInfoData.o_maas_cinfo_birth.replaceAll("-", "/")
          //   : "";
          // $("#birth")
          //   .pickadate("picker")
          //   .set("select", startDate, { format: "輸入格式: yyy(民國年)/mm/dd" });
          // $("#visa_birth")
          //   .pickadate("picker")
          //   .set("select", startDate, { format: "輸入格式: yyy(民國年)/mm/dd" });

          // startDate = this.CInfoData.o_maas_cinfo_issue_date
          //   ? this.CInfoData.o_maas_cinfo_issue_date.replaceAll("-", "/")
          //   : "";
          // $("#issue_date")
          //   .pickadate("picker")
          //   .set("select", startDate, { format: "輸入格式: yyy(民國年)/mm/dd" });
          // $("#visa_issue_date")
          //   .pickadate("picker")
          //   .set("select", startDate, { format: "輸入格式: yyy(民國年)/mm/dd" });

          // startDate = this.CInfoData.o_maas_cinfo_visa_limit_date
          //   ? this.CInfoData.o_maas_cinfo_visa_limit_date.replaceAll("-", "/")
          //   : "";
          // $("#visa_limit_date")
          //   .pickadate("picker")
          //   .set("select", startDate, { format: "輸入格式: yyy(民國年)/mm/dd" });

          if (this.CInfoData.o_maas_cinfo_card_imgf != "") {
            $("#card_imgf_preview").css(
              "background-image",
              'url("' +
              this.SiteUrl +
              this.CInfoData.o_maas_cinfo_card_imgf +
              '")'
            );
            $("#card_imgf_data").val(
              this.SiteUrl + this.CInfoData.o_maas_cinfo_card_imgf
            );
            $("#card_imgf_def").hide();
            $("#card_imgf_preview").show();
          }

          // if (this.CInfoData.o_maas_cinfo_photo != "") {
          //   $("#photo_img_preview").css(
          //     "background-image",
          //     'url("' + this.SiteUrl + this.CInfoData.o_maas_cinfo_photo + '")'
          //   );
          //   $("#photo_img_data").val(
          //     this.SiteUrl + this.CInfoData.o_maas_cinfo_photo
          //   );
          //   $("#photo_img_def").hide();
          //   $("#photo_img_preview").show();
          // }

          if (this.CInfoData.o_maas_cinfo_id_img != "") {
            $("#id_img_preview").css(
              "background-image",
              'url("' + this.SiteUrl + this.CInfoData.o_maas_cinfo_id_img + '")'
            );
            $("#id_img_data").val(
              this.SiteUrl + this.CInfoData.o_maas_cinfo_id_img
            );
            $("#id_img_def").hide();
            $("#id_img_preview").show();
          }

          if (this.CInfoData.o_maas_cinfo_visa_img != "") {
            $("#visa_img_preview").css(
              "background-image",
              'url("' +
              this.SiteUrl +
              this.CInfoData.o_maas_cinfo_visa_img +
              '")'
            );
            $("#visa_img_data").val(
              this.SiteUrl + this.CInfoData.o_maas_cinfo_visa_img
            );
            $("#visa_img_def").hide();
            $("#visa_img_preview").show();
          }

          if (this.CInfoData.o_maas_cinfo_visa_imgf != "") {
            $("#visa_imgf_preview").css(
              "background-image",
              'url("' +
              this.SiteUrl +
              this.CInfoData.o_maas_cinfo_visa_imgf +
              '")'
            );
            $("#visa_imgf_data").val(
              this.SiteUrl + this.CInfoData.o_maas_cinfo_visa_imgf
            );
            $("#visa_imgf_def").hide();
            $("#visa_imgf_preview").show();
          }
        }
        this.IsTester = response.data.IsTester;
        this.hasInvite = response.data.hasInvite;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  updated: function () { },
  mounted: function () {
    // 回頂端
    $(window).scrollTop(0);
    // 套用Class
    $(".wrapper").addClass("card");
    $(".wrapper").addClass("card-information-1");
    // i18n
    if (Storage.isKey("ek_site_lang")) {
      i18n.locale = Storage.get("ek_site_lang");
      this.local = Storage.get("ek_site_lang");
    } else {
      i18n.locale = "zh_tw";
      this.local = "zh_tw";
    }

    var that = this;

    $("#birth").mask("000/00/00", { placeholder: "077/07/07" });
    $("#issue_date").mask("000/00/00", { placeholder: "077/07/07" });
    $("#visa_birth").mask("000/00/00", { placeholder: "077/07/07" });
    $("#visa_issue_date").mask("000/00/00", { placeholder: "077/07/07" });
    $("#visa_limit_date").mask("000/00/00", { placeholder: "077/07/07" });
    $("#contact_mobile").mask("0000000000", { placeholder: "0977777777" });

    // $("#birth").pickadate({
    //   format: "輸入格式: yyy(民國年)/mm/dd",
    //   selectYears: true,
    //   selectMonths: true,
    //   selectYears: 100,
    //   max: new Date(),
    //   onSet: function (context) {
    //     if (context.select) {
    //       var date = new Date(context.select);
    //       var month = "" + (date.getMonth() + 1);
    //       var day = "" + date.getDate();
    //       var year = date.getFullYear() - 1911;
    //       if (month.length < 2) month = "0" + month;
    //       if (day.length < 2) day = "0" + day;
    //       that.birth = year + "/" + month + "/" + day;
    //       that.birth_real = year + 1911 + "/" + month + "/" + day;
    //     } else {
    //       that.birth = "";
    //       that.birth_real = "";
    //     }
    //   },
    // });

    // $("#issue_date").pickadate({
    //   format: "輸入格式: yyy(民國年)/mm/dd",
    //   selectYears: true,
    //   selectMonths: true,
    //   selectYears: 100,
    //   max: new Date(),
    //   onSet: function (context) {
    //     if (context.select) {
    //       var date = new Date(context.select);
    //       var month = "" + (date.getMonth() + 1);
    //       var day = "" + date.getDate();
    //       var year = date.getFullYear() - 1911;
    //       if (month.length < 2) month = "0" + month;
    //       if (day.length < 2) day = "0" + day;
    //       that.issue_date = year + "/" + month + "/" + day;
    //       that.issue_date_real = year + 1911 + "/" + month + "/" + day;
    //     } else {
    //       that.issue_date = "";
    //       that.issue_date_real = "";
    //     }
    //   },
    // });

    // $("#visa_birth").pickadate({
    //   format: "輸入格式: yyy(民國年)/mm/dd",
    //   selectYears: true,
    //   selectMonths: true,
    //   selectYears: 100,
    //   max: new Date(),
    //   onSet: function (context) {
    //     if (context.select) {
    //       var date = new Date(context.select);
    //       var month = "" + (date.getMonth() + 1);
    //       var day = "" + date.getDate();
    //       var year = date.getFullYear() - 1911;
    //       if (month.length < 2) month = "0" + month;
    //       if (day.length < 2) day = "0" + day;
    //       that.birth = year + "/" + month + "/" + day;
    //       that.birth_real = year + 1911 + "/" + month + "/" + day;
    //     } else {
    //       that.birth = "";
    //       that.birth_real = "";
    //     }
    //   },
    // });

    // $("#visa_issue_date").pickadate({
    //   format: "輸入格式: yyy(民國年)/mm/dd",
    //   selectYears: true,
    //   selectMonths: true,
    //   selectYears: 100,
    //   max: new Date(),
    //   onSet: function (context) {
    //     if (context.select) {
    //       var date = new Date(context.select);
    //       var month = "" + (date.getMonth() + 1);
    //       var day = "" + date.getDate();
    //       var year = date.getFullYear() - 1911;
    //       if (month.length < 2) month = "0" + month;
    //       if (day.length < 2) day = "0" + day;
    //       that.visa_issue_date = year + "/" + month + "/" + day;
    //     } else {
    //       that.visa_issue_date = "";
    //     }
    //   },
    // });

    // $("#visa_limit_date").pickadate({
    //   format: "輸入格式: yyy(民國年)/mm/dd",
    //   selectYears: true,
    //   selectMonths: true,
    //   selectYears: 100,
    //   max: new Date(),
    //   onSet: function (context) {
    //     if (context.select) {
    //       var date = new Date(context.select);
    //       var month = "" + (date.getMonth() + 1);
    //       var day = "" + date.getDate();
    //       var year = date.getFullYear() - 1911;
    //       if (month.length < 2) month = "0" + month;
    //       if (day.length < 2) day = "0" + day;
    //       that.visa_limit_date = year + "/" + month + "/" + day;
    //     } else {
    //       that.visa_limit_date = "";
    //     }
    //   },
    // });

    // var startDate =
    //   this.CInfoData != null
    //     ? this.CInfoData.o_maas_cinfo_birth.replaceAll("-", "/")
    //     : "";
    // if (startDate) {
    //   that.birth = startDate;
    //   $("#birth")
    //     .pickadate("picker")
    //     .set("select", startDate, { format: "輸入格式: yyy(民國年)/mm/dd" });
    //   $("#visa_birth")
    //     .pickadate("picker")
    //     .set("select", startDate, { format: "輸入格式: yyy(民國年)/mm/dd" });
    // }

    // startDate =
    //   this.CInfoData != null
    //     ? this.CInfoData.o_maas_cinfo_issue_date.replaceAll("-", "/")
    //     : "";
    // if (startDate) {
    //   that.issue_date = startDate;
    //   $("#issue_date")
    //     .pickadate("picker")
    //     .set("select", startDate, { format: "輸入格式: yyy(民國年)/mm/dd" });
    //   $("#visa_issue_date")
    //     .pickadate("picker")
    //     .set("select", startDate, { format: "輸入格式: yyy(民國年)/mm/dd" });
    // }

    // startDate =
    //   this.CInfoData != null
    //     ? this.CInfoData.o_maas_cinfo_visa_limit_date.replaceAll("-", "/")
    //     : "";
    // if (startDate) {
    //   that.visa_limit_date = startDate;
    //   $("#visa_limit_date")
    //     .pickadate("picker")
    //     .set("select", startDate, { format: "輸入格式: yyy(民國年)/mm/dd" });
    // }

    $(".custom-file-input").change(function () {
      if (this.files.length != 0) {
        // 顯示請稍候
        that.$swal({
          heightAuto: false,
          title: that.$t("圖片上傳中，請稍候。"),
          allowOutsideClick: false,
          showConfirmButton: false,
          willOpen: function () {
            that.$swal.showLoading();
          },
        });
        var id = $(this).attr("id");
        console.log(id);
        var file = this.files[0];
        lrz(file)
          .then(function (rst) {
            // 清空避免選同一張時無反應
            $("#" + id).val("");
            that.setImage(id, rst.base64);
          })
          .catch(function (err) {
            // 不進行壓縮的情況要檢查大小
            if (file.size > 5242880) {
              that.$swal({
                heightAuto: false,
                title: that.$t("錯誤"),
                html:
                  "檔案大小超過5MB<br />" +
                  "若您使用手機照相功能, 請嘗試降低相機畫質後再試一次<br />" +
                  "如持續發生此問題請聯繫客服人員, 造成不便敬請見諒",
                icon: "error",
                allowOutsideClick: false,
                confirmButtonText: that.$t("確定"),
              });
            } else {
              var reader = new FileReader();
              reader.onloadend = function () {
                $("#" + id).val("");
                that.setImage(id, reader.result);
              };
              reader.onerror = function (error) {
                $("#" + id).val("");
                that.$swal({
                  heightAuto: false,
                  title: that.$t("錯誤"),
                  html:
                    "處理圖片過程發生錯誤:<br />" +
                    error +
                    "<br />若持續發生此問題請聯繫客服人員, 造成不便敬請見諒",
                  icon: "error",
                  allowOutsideClick: false,
                  confirmButtonText: that.$t("確定"),
                });
              };
              reader.readAsDataURL(file);
            }
          })
          .always(function () { });
      }
    });

    // $("#cardType").on("change", function () {
    //   var value = $(this).find("option:selected").val();
    //   if (value == 0) {
    //     $("#studentInfo").hide();
    //     $("#cardNumber").show();
    //   } else if (value == 2) {
    //     $("#studentInfo").show();
    //     $("#cardNumber").show();
    //   } else {
    //     $("#studentInfo").hide();
    //     $("#cardNumber").hide();
    //   }
    // });
  },
  methods: {
    gotoStep(step) {
      if (step == 1) {
        $("#App").addClass("card-information-1");
        $("#App").removeClass("card-information-2");
        $("#App").removeClass("card-information-3");
        $("#step_1").show();
        $("#step_2").hide();
        $("#step_3").hide();
      } else if (step == 2) {
        if (this.cardType == -1) {
          this.$swal({
            heightAuto: false,
            title: this.$t("錯誤"),
            text: "請選擇卡片類型",
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: this.$t("確定"),
          });
          return;
        }
        if (this.cardType == 0 || this.cardType == 2) {
          if (this.cardNo == "") {
            this.$swal({
              heightAuto: false,
              title: this.$t("錯誤"),
              text: "請填寫卡片背面號碼",
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: this.$t("確定"),
            });
            return;
          }
          if ($("#card_imgf_data").val() == "") {
            this.$swal({
              heightAuto: false,
              title: this.$t("錯誤"),
              text: "請上傳卡片背面照片",
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: this.$t("確定"),
            });
            return;
          }
        }
        // if ($("#photo_img_data").val() == "") {
        //   this.$swal({
        //     heightAuto: false,
        //     title: this.$t("錯誤"),
        //     text: "請上傳大頭照",
        //     icon: "error",
        //     allowOutsideClick: false,
        //     confirmButtonText: this.$t("確定"),
        //   });
        //   return;
        // }
        $("#App").removeClass("card-information-1");
        $("#App").addClass("card-information-2");
        $("#App").removeClass("card-information-3");
        $("#step_1").hide();
        $("#step_2").show();
        $("#step_3").hide();
      } else if (step == 3) {
        if (
          this.ident_type == 1 &&
          (this.ident == "" ||
            this.name == "" ||
            this.birth == "" ||
            this.issue_date == "" ||
            this.issue_place == "" ||
            this.issue_type == "" ||
            $("#id_img_data").val() == "" ||
            this.contact_mobile == "")
        ) {
          this.$swal({
            heightAuto: false,
            title: this.$t("錯誤"),
            text: "請確實填寫所有資料",
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: this.$t("確定"),
          });
          return;
        } else if (
          this.ident_type == 2 &&
          (this.ident == "" ||
            this.name == "" ||
            this.birth == "" ||
            this.issue_date == "" ||
            (!this.visa_no_limit && this.visa_limit_date == "") ||
            $("#visa_img_data").val() == "" ||
            $("#visa_imgf_data").val() == "" ||
            this.contact_mobile == "")
        ) {
          this.$swal({
            heightAuto: false,
            title: this.$t("錯誤"),
            text: "請確實填寫所有資料",
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: this.$t("確定"),
          });
          return;
        }
        if (
          !this.contact_mobile.startsWith("09") ||
          this.contact_mobile.length != 10
        ) {
          this.$swal({
            heightAuto: false,
            title: this.$t("錯誤"),
            text: this.$t("手機號碼格式錯誤"),
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: this.$t("確定"),
          });
          return;
        }

        if (
          this.invitCode && this.invitCode.length !== 12 && this.invitCode.length !== 13
        ) {
          this.$swal({
            heightAuto: false,
            title: this.$t("錯誤"),
            text: this.$t("好友邀請碼格式錯誤"),
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: this.$t("確定"),
          });
          return;
        }

        switch (this.visa_country) {
          case 0:
            this.visa_country_text = "台灣";
            break;
          case 1:
            this.visa_country_text = "其他";
            break;
          case 2:
            this.visa_country_text = "中國";
            break;
          case 3:
            this.visa_country_text = "港澳";
            break;
          case 4:
            this.visa_country_text = "日本";
            break;
          case 5:
            this.visa_country_text = "韓國";
            break;
          case 6:
            this.visa_country_text = "東南亞";
            break;
        }
        if (!this.visa_no_limit) {
          this.visa_limit_date_text = this.visa_limit_date;
        } else {
          this.visa_limit_date_text = "外僑永久居留證";
        }
        $("#App").removeClass("card-information-1");
        $("#App").removeClass("card-information-2");
        $("#App").addClass("card-information-3");
        $("#step_1").hide();
        $("#step_2").hide();
        $("#step_3").show();
      }
      this.step = step;
      $(window).scrollTop(0);
    },
    getFile(id) {
      $("#" + id).click();
    },
    getPhoto(id) {
      let that = this;

      navigator.camera.getPicture(onSuccess, onFail, {
        quality: 50,
        destinationType: Camera.DestinationType.DATA_URL,
      });

      function onSuccess(imageData) {
        that.$swal({
          heightAuto: false,
          title: that.$t("圖片上傳中，請稍候。"),
          allowOutsideClick: false,
          showConfirmButton: false,
          willOpen: function () {
            that.$swal.showLoading();
          },
        });
        lrz(imageData)
          .then(function (rst) {
            that.setImage(id, rst.base64);
          })
          .catch(function (err) {
            // 不進行壓縮的情況要檢查大小
            var buffer = Buffer.from(imageData);
            // 不進行壓縮的情況要檢查大小
            if (buffer.length > 5242880) {
              that.$swal({
                heightAuto: false,
                title: that.$t("錯誤"),
                html:
                  "檔案大小超過5MB<br />" +
                  "若您使用手機照相功能, 請嘗試降低相機畫質後再試一次<br />" +
                  "如持續發生此問題請聯繫客服人員, 造成不便敬請見諒",
                icon: "error",
                allowOutsideClick: false,
                confirmButtonText: that.$t("確定"),
              });
            } else {
              that.setImage(id, imageData);
            }
          })
          .always(function () { });
      }
      function onFail(message) { }
    },
    setImage(id, rst) {
      let that = this;
      // 判斷是否略過OCR
      var noocr = false;
      if (id.startsWith("noocr_")) {
        noocr = true;
        id = id.replaceAll("noocr_", "");
      }

      $('#ocrCaptionModal').modal('hide');
      $("#" + id + "_preview").css("background-image", 'url("' + rst + '")');
      $("#" + id + "_data").val(rst);
      $("#" + id + "_def").hide();
      $("#" + id + "_preview").show();

      if (!noocr) {
        if (id == "card_imgf") {
          // OCR
          $.ajax({
            type: "post",
            url:
              that.GLOBAL.apiSrc + that.GLOBAL.subDirectory + "/Htmlv2/GetOCR",
            data: {
              token: Storage.get("ek_login_token"),
              file: rst,
              type: "card",
            },
            error: function () {
              that.$swal({
                heightAuto: false,
                title: that.$t("錯誤"),
                text: "傳輸過程發生錯誤, 請稍後再試一次",
                icon: "error",
                allowOutsideClick: false,
                confirmButtonText: that.$t("確定"),
              });
            },
            success: function (result) {
              if (result.ok) {
                that.cardNo = result.IPASS_SN;
                that.$swal.close();
              } else if (result.error) {
                var error_msg = JSON.parse(result.error_msg);
                that.$swal({
                  heightAuto: false,
                  title: that.$t("錯誤"),
                  text: error_msg[i18n.locale],
                  icon: "error",
                  allowOutsideClick: false,
                  confirmButtonText: that.$t("確定"),
                });
              }
            },
          });
        } else if (id == "id_img") {
          // OCR
          $.ajax({
            type: "post",
            url:
              that.GLOBAL.apiSrc + that.GLOBAL.subDirectory + "/Htmlv2/GetOCR",
            data: {
              token: Storage.get("ek_login_token"),
              file: rst,
              type: "iden",
            },
            error: function () {
              that.$swal({
                heightAuto: false,
                title: that.$t("錯誤"),
                text: "傳輸過程發生錯誤, 請稍後再試一次",
                icon: "error",
                allowOutsideClick: false,
                confirmButtonText: that.$t("確定"),
              });
            },
            success: function (result) {
              if (result.ok) {
                that.ident = result.ident;
                that.name = result.name;
                that.issue_place = result.issue_place;
                that.issue_type = result.issue_type;
                that.birth = result.birth;
                that.issue_date = result.issue_date;

                // $("#birth")
                //   .pickadate("picker")
                //   .set("select", result.birth, { format: "輸入格式: yyy(民國年)/mm/dd" });
                // $("#issue_date")
                //   .pickadate("picker")
                //   .set("select", result.issue_date, {
                //     format: "輸入格式: yyy(民國年)/mm/dd",
                //   });
                that.$swal.close();
              } else if (result.error) {
                var error_msg = JSON.parse(result.error_msg);
                that.$swal({
                  heightAuto: false,
                  title: that.$t("錯誤"),
                  text: error_msg[i18n.locale],
                  icon: "error",
                  allowOutsideClick: false,
                  confirmButtonText: that.$t("確定"),
                });
              }
            },
          });
        } else {
          that.$swal.close();
        }
      } else {
        that.$swal.close();
      }
    },
    cardApply() {
      let that = this;

      // 顯示請稍候
      this.$swal({
        heightAuto: false,
        title: this.$t("請稍候..."),
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: function () {
          that.$swal.showLoading();
        },
      });

      // Step 1
      if (this.cardType == 0 || this.cardType == 2) {
        if (this.cardNo == "") {
          this.$swal({
            heightAuto: false,
            title: this.$t("錯誤"),
            text: "請填寫卡片背面號碼",
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: this.$t("確定"),
          });
          return;
        }
        if ($("#card_imgf_data").val() == "") {
          this.$swal({
            heightAuto: false,
            title: this.$t("錯誤"),
            text: "請上傳卡片背面照片",
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: this.$t("確定"),
          });
          return;
        }
      }

      // Step 2
      // if ($("#photo_img_data").val() == "") {
      //   this.$swal({
      //     heightAuto: false,
      //     title: this.$t("錯誤"),
      //     text: "請上傳大頭照",
      //     icon: "error",
      //     allowOutsideClick: false,
      //     confirmButtonText: this.$t("確定"),
      //   });
      //   return;
      // }

      // Step 3
      if (
        this.ident_type == 1 &&
        (this.ident == "" ||
          this.name == "" ||
          this.birth == "" ||
          this.issue_date == "" ||
          this.issue_place == "" ||
          this.issue_type == "" ||
          $("#id_img_data").val() == "" ||
          this.contact_mobile == "")
      ) {
        this.$swal({
          heightAuto: false,
          title: this.$t("錯誤"),
          text: "請確實填寫所有資料",
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: this.$t("確定"),
        });
        return;
      } else if (
        this.ident_type == 2 &&
        (this.ident == "" ||
          this.name == "" ||
          this.birth == "" ||
          this.issue_date == "" ||
          (!this.visa_no_limit && this.visa_limit_date == "") ||
          $("#visa_img_data").val() == "" ||
          $("#visa_imgf_data").val() == "" ||
          this.contact_mobile == "")
      ) {
        this.$swal({
          heightAuto: false,
          title: this.$t("錯誤"),
          text: "請確實填寫所有資料",
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: this.$t("確定"),
        });
        return;
      }

      // 電話號碼獨立檢查
      if (
        !this.contact_mobile.startsWith("09") ||
        this.contact_mobile.length != 10
      ) {
        this.$swal({
          heightAuto: false,
          title: this.$t("錯誤"),
          text: this.$t("手機號碼格式錯誤"),
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: this.$t("確定"),
        });
        return;
      }

      if (
        this.invitCode && this.invitCode.length !== 12 && this.invitCode.length !== 13
      ) {
        this.$swal({
          heightAuto: false,
          title: this.$t("錯誤"),
          text: this.$t("好友邀請碼格式錯誤"),
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: this.$t("確定"),
        });
        return;
      }

      $.ajax({
        url: that.GLOBAL.apiSrc + that.GLOBAL.subDirectory + "/Htmlv2/CardBind",
        type: "post",
        data: {
          token: Storage.get("ek_login_token"),
          // Step 1
          cardType: that.cardType,
          cardNo: that.cardNo,
          expire: that.expire,
          // Step 2
          ident_type: that.ident_type,
          ident: that.ident,
          name: that.name,
          birth: that.birth,
          issue_date: that.issue_date,
          issue_place: that.issue_place,
          issue_type: that.issue_type,
          visa_country: that.visa_country,
          visa_limit_date: that.visa_limit_date,
          visa_no_limit: that.visa_no_limit,
          card_imgf_data: $("#card_imgf_data").val(),
          //photo_img_data: $("#photo_img_data").val(),
          id_img_data: $("#id_img_data").val(),
          visa_img_data: $("#visa_img_data").val(),
          visa_imgf_data: $("#visa_imgf_data").val(),
          contact_mobile: that.contact_mobile,
          invitCode: that.invitCode,
        },
        dataType: "json",
        error: function () { },
        success: function (res) {
          // 判斷結果
          if (res.ok) {
            if (that.invitCode) {
              that.$swal({
                heightAuto: false,
                icon: "success",
                title: that.$t("提交完成"),
                text: that.$t(
                  "申請資料提交完成，您已可購買QR Code/卡片月週票搭乘各運具。"
                ),
                showConfirmButton: true,
                showDenyButton: true,
                confirmButtonText: "前往優惠專區",
                denyButtonText: "回到首頁",
                allowOutsideClick: false,
              }).then((result) => {
                if (result.isConfirmed) {
                  that.$router.push("/MemberCoupon");
                } else {
                  that.$router.push("/");
                }
              });
            } else {
              that.$swal({
                heightAuto: false,
                icon: "success",
                title: that.$t("提交完成"),
                text: that.$t(
                  "申請資料提交完成，您已可購買QR Code/卡片月週票搭乘各運具。"
                ),
                showConfirmButton: false,
                timer: 3000,
                didDestroy: () => {
                  // 轉到首頁
                  that.$router.push("/");
                },
                allowOutsideClick: false,
              });
            }
          } else if (res.error_msg) {
            var error_msg = JSON.parse(res.error_msg);
            that.$swal({
              heightAuto: false,
              title: that.$t("錯誤"),
              text: error_msg[i18n.locale],
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: that.$t("確定"),
            });
          }
        },
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.information-box .photograph .btn {
  width: initial;
  padding: 3px 15px;
  float: initial;
  position: initial;
  font-size: 1.1rem;
  font-weight: 400;
  padding-top: 5px;
}


.card-information-2 .modal-body .btn_box {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}

.card-information-2 .modal-body .btn_box button {
  display: flex;
  align-items: center;
  margin: 15px 10px;
  margin-top: 0;
  padding: 5px 20px;
  padding-top: 7px;
}

.card-information-2 .modal-body .btn_box img {
  width: 25px;
  margin-right: 8px;
  border-radius: 0;
  padding-bottom: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/CardBind.vue